import React, { useState } from 'react';
import { FaHome, FaTimes, FaUserCog ,FaLifeRing} from 'react-icons/fa';
import { LuFileStack } from "react-icons/lu";
import { BsBoxSeamFill } from "react-icons/bs";
import USPS2 from '../../Assets/USPS2.jpg';
import { useNotificationContext } from '../../context/NotificationContext';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext';
import { MdQuestionMark, MdOutlineEmail } from 'react-icons/md';
import { FaPhone, FaRegMessage } from 'react-icons/fa6';
import { GrSupport } from 'react-icons/gr';
import { IoBug } from 'react-icons/io5';
import { BsPatchCheck, BsFillBellFill } from 'react-icons/bs';
import { IoCaretDown,IoCaretUp } from "react-icons/io5";


const Sidebar = ({ isOpen, closeMenu }) => {
  const [activeModal, setActiveModal] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const nav = useNavigate();

  const { messages, notifications, shownMessageCount, shownNotificationCount } = useNotificationContext();
 const {logout} = useAppContext()
  const toggleModal = (modalName) => {
    setActiveModal(prev => (prev === modalName ? null : modalName));
  };

  return (
    <aside
      className={`
        fixed top-0 left-0 h-screen w-full md:w-60 z-30 md:translate-x-0
        transform transition-transform duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
      `}
    >
      <div className="h-full w-full bg-gray-800 text-white p-4 overflow-y-auto">
        
        {/* Mobile close */}
        <div className="flex justify-end mb-4 md:hidden mr-10">
          <button onClick={closeMenu}>
            <FaTimes size={24} />
          </button>
        </div>

        {/* ================= MAIN NAV ================= */}
        <nav className="flex flex-col space-y-6 mt-20" >

          <button  onClick={() => {nav('/dashboard');closeMenu()}} className="flex items-center space-x-2 hover:text-gray-300">
            <FaHome size={22}/> <span >Dashboard</span>
          </button>

          <button onClick={() => nav('/dashboard/informdelv')} className="flex items-center space-x-2 hover:text-gray-300">
            <BsBoxSeamFill  size={22}/> <span >Informed Delivery</span>
          </button>

   {/* List Processing */}
          <div>
            <button
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              className="flex items-center space-x-2 hover:text-gray-300 w-full text-left"
            >
              <LuFileStack  size={22}/>
              <span style={{display:'inline-block'}}>List Processing</span> {isDropdownOpen ? <IoCaretUp /> :<IoCaretDown /> }
            </button>

            {isDropdownOpen && (
              <div className="ml-8 mt-2 space-y-6 mt-6">
              <button
  onClick={() => {
    nav('/dashboard/newjob');
    setIsDropdownOpen(false);
    closeMenu();
  }}
  className="block hover:text-gray-400"
>
  Submit New Job
</button>

                <button onClick={() => nav('/dashboard/jobs')} className="block hover:text-gray-400">
                  Completed Jobs
                </button>
                <button onClick={() => {nav('/dashboard/permits');closeMenu()}} className="block hover:text-gray-400">
                  Mail Settings
                </button>
              </div>
            )}
          </div>
          <button onClick={() => nav('/dashboard/promotions')} className="flex items-center space-x-2 hover:text-gray-300">
            <img src={USPS2} alt="PostagePal" className="w-5 h-5 object-contain" />
            <span>PostagePal Promotions</span>
          </button>

       

        </nav>

        <hr className="my-5 border-gray-700" />

        {/* ================= MOBILE ICON SECTION ================= */}
        <div className="md:hidden w-full space-y-2 relative">
          
          {/* Messages */}
          <div className="relative">
            <button
              onClick={() => toggleModal('messages')}
              className="flex items-center space-x-2 w-full px-4 py-2 hover:bg-gray-700 rounded relative"
            >
              <FaRegMessage size={20} />
              <span>Messages</span>
              {shownMessageCount > 0 && (
                <span className="absolute right-4 bg-red-600 text-xs rounded-full h-5 w-5 flex items-center justify-center">
                  {shownMessageCount}
                </span>
              ) }
            </button>

            {activeModal === 'messages' && (
              <div className="mt-2 bg-white text-black rounded-lg shadow-md p-3 z-40">
               {messages.length > 0 ?  messages?.map((notice, i) => <p key={i}>{notice}</p>) : 'No messages at this time.'}

              </div>
            )}
          </div>

          {/* Notifications */}
          <div className="relative">
            <button
              onClick={() => toggleModal('notifications')}
              className="flex items-center space-x-2 w-full px-4 py-2 hover:bg-gray-700 rounded relative"
            >
              <BsFillBellFill size={20} />
              <span>Notifications</span>
              {shownNotificationCount > 0 && (
                <span className="absolute right-4 bg-red-600 text-xs rounded-full h-5 w-5 flex items-center justify-center">
                  {shownNotificationCount}
                </span>
              )}
            </button>

            {activeModal === 'notifications' && (
              <div className="mt-2 bg-white text-black rounded-lg shadow-lg p-3 z-40">
               
                 {notifications.length > 0 ?  notifications?.map((notice, i) => <p key={i}>{notice}</p>) : 'No notifications at this time.'}
              </div>
            )}
          </div>

  {/* Help */}
{/* Support */}
<div className="relative">
  <button
    onClick={() => toggleModal('help')}
    className="flex items-center space-x-2 w-full px-4 py-2 hover:bg-gray-700 rounded relative"
  >
    <FaLifeRing size={20} />
    <span>Support</span>
  </button>

  {activeModal === 'help' && (
    <div className="mt-2 bg-white text-black rounded-lg shadow-lg p-3 z-40 space-y-2 text-sm">
      
      <p className="font-semibold border-b pb-1">Need help?</p>

      <button className="flex items-center gap-2 w-full hover:bg-gray-100 px-2 py-1 rounded">
        <MdQuestionMark size={18} />
        <span>FAQs</span>
      </button>

      <button className="flex items-center gap-2 w-full hover:bg-gray-100 px-2 py-1 rounded">
        <MdOutlineEmail size={18} />
        <span>Email Us</span>
      </button>

      <button className="flex items-center gap-2 w-full hover:bg-gray-100 px-2 py-1 rounded">
        <FaPhone size={16} />
        <span>(800) Lightning</span>
      </button>

      <button className="flex items-center gap-2 w-full hover:bg-gray-100 px-2 py-1 rounded">
        <GrSupport size={18} />
        <span>Support</span>
      </button>

      <button className="flex items-center gap-2 w-full hover:bg-gray-100 px-2 py-1 rounded">
        <IoBug size={18} />
        <span>Report a Bug</span>
      </button>

      <button className="flex items-center gap-2 w-full hover:bg-gray-100 px-2 py-1 rounded">
        <BsPatchCheck size={18} />
        <span>Recent Updates</span>
      </button>
 <button className="flex items-center gap-2 w-full hover:bg-gray-100 px-2 py-1 rounded">
        <BsPatchCheck size={18} />
        <span>Share Your Feedback</span>
      </button>
    </div>
  )}
</div>

         
          <div className="relative">
            <button
              onClick={() => toggleModal('profile')}
              className="flex items-center space-x-2 w-full px-4 py-2 hover:bg-gray-700 rounded"
            >
              <FaUserCog size={20} />
              <span>User</span>
            </button>

            {activeModal === 'profile' && (
              <div className="mt-2 bg-white text-black rounded-lg shadow-lg p-3 z-40">
                <button className="block w-full text-left hover:bg-gray-100 px-2 py-1 rounded">
                  Account
                </button>
                <button className="block w-full text-left hover:bg-gray-100 px-2 py-1 rounded">
                  Settings
                </button>
                <button className="block w-full text-left hover:bg-gray-100 px-2 py-1 rounded text-red-600" onClick={e => logout()}>
                  Logout
                </button>
              </div>
            )}
          </div>

        </div>
      </div>
    </aside>
  );
};

export default Sidebar;

